import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactSVG } from 'react-svg';
import b2c from './../assets/images/b2c.svg';
import b2b from './../assets/images/b2b.svg';
import rv from './../assets/images/rv.svg';
import { connect } from 'react-redux';
import { startLoginOrExplain } from '../actions/login';
import { popup_VrInfo_SetVisibility } from '../actions/popup';

// The service tiles of open-brand homepages, post popup removal: RV opens the
// dealer-contact info popup (no self-signup exists for it), Corporate starts
// the Keycloak login - registration continues post-login through the company
// resolution flow. Private stays what it always was, a plain tile.
class BusinessTabs extends Component {
  constructor(props) {
    super(props);
    this.showVrInfo = this.showVrInfo.bind(this);
    this.startLogin = this.startLogin.bind(this);
  }

  showVrInfo() {
    this.props.popup_VrInfo_SetVisibility(true);
  }

  startLogin() {
    this.props.startLoginOrExplain();
  }

  render() {
    return (
      <div className="business-tabs">
        <div>
          <ReactSVG wrapper="span" className="react-svg" src={b2c} />
          <FormattedMessage id="service.usage.private" />
        </div>
        <div onClick={this.showVrInfo}>
          <ReactSVG wrapper="span" className="react-svg" src={rv} />
          <FormattedMessage id="service.usage.vr" />
        </div>
        <div onClick={this.startLogin}>
          <ReactSVG wrapper="span" className="react-svg" src={b2b} />
          <FormattedMessage id="service.usage.corporate" />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { startLoginOrExplain, popup_VrInfo_SetVisibility };

export default connect(null, mapDispatchToProps)(BusinessTabs);
